export default "/de/katalog/@slug";
